import { Modal, Button } from 'react-bootstrap';

const HelpModal = ({ show, handleClose }) => {
    const presentations = [
        { name: 'Cápsulas', abbr: 'CAP' },
        { name: 'Tabletas', abbr: 'TAB' },
        { name: 'Softgel', abbr: 'SFG' },
        { name: 'Gummies', abbr: 'GUM' },
        { name: 'Polvo', abbr: 'PWD' },
        { name: 'Líquido', abbr: 'LIQ' },
        { name: 'Shot bebible', abbr: 'SHT' },
        { name: 'Efervescente', abbr: 'EFF' },
        { name: 'Tiras orales', abbr: 'STR' },
        { name: 'Discos blandos', abbr: 'SCW' },
        { name: 'Stick cosmético', abbr: 'STB' },
        { name: 'Loción', abbr: 'LOC' },
        { name: 'Spray oral', abbr: 'SPY' },
        { name: 'Stick pack', abbr: 'STK' },
        { name: 'Sachet', abbr: 'SCH' },
        { name: 'Gotas', abbr: 'DRP' },
        { name: 'Crema', abbr: 'CRM' },
        { name: 'Sérum', abbr: 'SRM' },
        { name: 'Gel', abbr: 'GEL' },
        { name: 'Ampolla', abbr: 'AMP' },
        { name: 'Mascarilla', abbr: 'MSK' },
        { name: 'Spray facial', abbr: 'FSP' },
        { name: 'Parche', abbr: 'PTC' },
        { name: 'Unidad', abbr: 'UND' },
    ];

    const weights = [
        { name: 'Gramos', abbr: 'GR' },
        { name: 'Kilogramos', abbr: 'KG' },
        { name: 'Libras', abbr: 'LB' },
        { name: 'Onzas', abbr: 'OZ' },
    ];

    const dimensions = [
        { name: 'Centímetros', abbr: 'CM' },
        { name: 'Metros', abbr: 'MT' },
        { name: 'Pulgadas', abbr: 'IN' },
        { name: 'Pies', abbr: 'FT' },
    ];

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="lg"
            centered
            scrollable
            className="help-modal">
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fas fa-question-circle mr-2"></i>
                    <strong>Validaciones de Campos</strong>
                    <h6>Revisa las siguientes validaciones que se aplicarán a tu archivo CSV</h6>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <div className="mb-4">
                    <h6 className="font-weight-bold text-primary">
                        <i className="fas fa-shield-alt mr-2"></i>Robustez del sistema
                    </h6>
                    <div className="pl-3">
                        <p className="mb-2">
                            <strong>Flexibilidad de formato general:</strong> El sistema acepta mayúsculas, minúsculas y tildes en campos de tipo texto, sin generar errores.
                        </p>
                        <p className="mb-0">
                            <strong>Tolerancia a espacios:</strong> El sistema elimina espacios en blanco al
                            inicio y al final de los campos.
                        </p>
                    </div>
                </div>

                <hr />

                <div className="mb-4">
                    <h6 className="font-weight-bold text-primary">
                        <i className="fas fa-box mr-2"></i>Presentación (debe usar la abreviatura)
                    </h6>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered" style={{ fontSize: '0.9rem' }}>
                            <thead className="table-light">
                                <tr>
                                    <th>Nombre</th>
                                    <th>Abreviatura</th>
                                    <th>Nombre</th>
                                    <th>Abreviatura</th>
                                </tr>
                            </thead>
                            <tbody>
                                {presentations.slice(0, 12).map((item, idx) => (
                                    <tr key={idx}>
                                        <td>{item.name}</td>
                                        <td className="text-monospace">{item.abbr}</td>
                                        {presentations[idx + 12] && (
                                            <>
                                                <td>{presentations[idx + 12].name}</td>
                                                <td className="text-monospace">{presentations[idx + 12].abbr}</td>
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <hr />

                <div className="mb-4">
                    <h6 className="font-weight-bold text-primary">
                        <i className="fas fa-weight mr-2"></i>Unidad de peso (debe usar la abreviatura)
                    </h6>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered" style={{ fontSize: '0.9rem' }}>
                            <thead className="table-light">
                                <tr>
                                    <th>Nombre</th>
                                    <th>Abreviatura</th>
                                </tr>
                            </thead>
                            <tbody>
                                {weights.map((item, idx) => (
                                    <tr key={idx}>
                                        <td>{item.name}</td>
                                        <td className="text-monospace">{item.abbr}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <hr />

                <div className="mb-4">
                    <h6 className="font-weight-bold text-primary">
                        <i className="fas fa-ruler mr-2"></i>Unidad de dimensiones (debe usar la abreviatura)
                    </h6>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered" style={{ fontSize: '0.9rem' }}>
                            <thead className="table-light">
                                <tr>
                                    <th>Nombre</th>
                                    <th>Abreviatura</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dimensions.map((item, idx) => (
                                    <tr key={idx}>
                                        <td>{item.name}</td>
                                        <td className="text-monospace">{item.abbr}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <hr />

                <div className="mb-4">
                    <h6 className="font-weight-bold text-primary">
                        <i className="fas fa-check-circle mr-2"></i>Validaciones por campo
                    </h6>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered" style={{ fontSize: '0.85rem' }}>
                            <thead className="table-light">
                                <tr>
                                    <th>Tipo de validación</th>
                                    <th>Campo(s)</th>
                                    <th>Regla aplicada</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="table-warning">
                                    <td>Obligatoriedad</td>
                                    <td>Todos (*)</td>
                                    <td>Los campos marcados con * no deben estar vacíos</td>
                                </tr>
                                <tr>
                                    <td>Longitud/Formato</td>
                                    <td>Código de barras</td>
                                    <td>Máximo 14 caracteres.</td>
                                </tr>
                                <tr>
                                    <td>Estructura de ID</td>
                                    <td>Subcategoría</td>
                                    <td>El ID debe existir en el maestro de subcategorías (ej: 1, 2, 3...)</td>
                                </tr>
                                <tr>
                                    <td>Unicidad por contexto</td>
                                    <td>ID Externo (SKU), Abreviatura, Código de barras, Nombre</td>
                                    <td>No deben repetirse dentro del mismo archivo</td>
                                </tr>
                                <tr>
                                    <td>Lógica/Rango</td>
                                    <td>Plazo máximo para despachar</td>
                                    <td>Debe ser mayor a 0. Si se proporciona Vida útil (días) y Plazo máximo para despachar, el Plazo máximo para despachar debe ser menor a la Vida útil (días)</td>
                                </tr>
                                <tr>
                                    <td>Formato/Numérico</td>
                                    <td>Peso, Costo, Valor Comercial, Ancho, Alto, Largo, Vida útil y Plazo máximo para despachar</td>
                                    <td>Debe ser numérico y &gt; 0</td>
                                </tr>
                                <tr>
                                    <td>Longitud/Formato</td>
                                    <td>Nombre del producto</td>
                                    <td>Mínimo 3 a máximo 100 caracteres</td>
                                </tr>
                                <tr>
                                    <td>Longitud/Formato</td>
                                    <td>Abreviatura</td>
                                    <td>Máximo 10 caracteres. No permite espacios</td>
                                </tr>
                                <tr>
                                    <td>Longitud/Formato</td>
                                    <td>Item master</td>
                                    <td>Máximo 30 caracteres. Solo caracteres alfanuméricos, no permite espacios</td>
                                </tr>
                                <tr>
                                    <td>Longitud/Formato</td>
                                    <td>ID Externo (SKU)</td>
                                    <td>Máximo 30 caracteres. No permite espacios</td>
                                </tr>
                                <tr>
                                    <td>Longitud/Formato</td>
                                    <td>Descripción del producto</td>
                                    <td>Máximo 100 caracteres</td>
                                </tr>
                                <tr>
                                    <td>Longitud/Formato</td>
                                    <td>Unidad de medida para recibo</td>
                                    <td>Máximo 100 caracteres</td>
                                </tr>
                                <tr>
                                    <td>Longitud/Formato</td>
                                    <td>Unidad de medida para despacho</td>
                                    <td>Máximo 100 caracteres</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="alert alert-info" role="alert">
                    <i className="fas fa-lightbulb mr-2"></i>
                    <strong>Consejo:</strong> Descargar la plantilla incluye todas las columnas necesarias.
                    Completa cada fila con los datos de tu producto siguiendo estas validaciones.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant='primary'
                    onClick={handleClose}>
                    Entendido
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default HelpModal;
